import styled from "styled-components";

export const ExhibitionCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  padding: 8px;

  border-radius: 4px;

  border: 1px solid #e0e0e0;

  background-color: #f5f5f5;
`;

export const ExhibitionCardContent = styled.div`
  h1 {
    font-size: 1.2rem;
    font-weight: 600;
    margin-bottom: 8px;
  }

  p {
    font-size: 0.9rem;
    color: #666;
    margin-bottom: 8px;
  }

  span {
    font-size: 0.8rem;
    margin-bottom: 8px;
    font-weight: 600;
  }
`;

export const ExhibitionCardActions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding: 4px;
  margin-top: 18px;
`;
